import { render, staticRenderFns } from "./StudentDistrict.vue?vue&type=template&id=2e548e02&"
import script from "./StudentDistrict.js?vue&type=script&lang=js&"
export * from "./StudentDistrict.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports